// // routes/PrivateRoute.js
// import { Navigate } from 'react-router-dom';
// import { isAuthenticated, getRole } from '../auth';

// export default function PrivateRoute({ children, roles }) {
//   if (!isAuthenticated()) return <Navigate to="/login" />;
//   if (roles && !roles.includes(getRole())) return <Navigate to="/unauthorized" />;
//   return children;
// }


import { Navigate } from 'react-router-dom';
import { isAuthenticated, getRole } from '../auth';

export default function PrivateRoute({ children, roles }) {
  // Redirect if not logged in
  if (!isAuthenticated()) return <Navigate to="/login" />;

  // Redirect if logged in but not authorized
  if (roles && !roles.includes(getRole())) return <Navigate to="/unauthorized" />;

  // Allow access if authenticated and authorized
  return children;
}

